import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "text-muted align-middle mb-0" }
const _hoisted_3 = {
  key: 0,
  class: "col-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sub_section = _resolveComponent("sub-section")!
  const _component_state_pension_editor = _resolveComponent("state-pension-editor")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_sub_section, {
      title: "Your State Pension",
      helpTitle: "Your State Pension",
      helpText: _ctx.HelpText.statePension()
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["d-flex align-items-center", _ctx.isOverSPA ? 'col-10' : 'col'])
          }, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.statePensionText), 1)
          ], 2),
          (_ctx.isOverSPA)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-sm float-end",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onEditClicked($event)))
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("span", { class: "d-none d-sm-inline-block me-2" }, "Edit", -1),
                  _createElementVNode("i", { class: "bi bi-pencil-square" }, null, -1)
                ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["helpText"]),
    _createVNode(_component_modal, {
      title: "State Pension",
      ref: "statePensionModal",
      idKey: "statePensionModal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_state_pension_editor, {
          ref: "statePensionEditor",
          onEditFinished: _ctx.onEditFinished
        }, null, 8, ["onEditFinished"])
      ]),
      _: 1
    }, 512)
  ], 64))
}